import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HeroSection } from '@/components/hero/HeroSection';
import { HeroIllustration } from '@/components/hero/HeroIllustration';
import { FeaturesSection } from '@/components/marketing/FeaturesSection';
import { BeforeAfterSection } from '@/components/marketing/BeforeAfterSection';
import { PricingSection } from '@/components/marketing/PricingSection';
import { TestimonialsSection } from '@/components/testimonials';
import { MobileHero } from '@/components/mobile/MobileHero';
import { AnimatedBackground } from '@/components/ui/AnimatedBackground';
import { Footer } from '@/components/ui/Footer';
import { EnhancedHeader } from '@/components/ui/EnhancedHeader';
import { useBreakpoint } from '@/hooks/useBreakpoint';

const LandingPage: React.FC = () => {
  const { isMobile } = useBreakpoint();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/auth/register');
  };

  const handleWatchDemo = () => {
    // TODO: Open demo modal or navigate to demo page
    console.log('Watch Demo clicked');
  };

  const handleLogin = () => {
    navigate('/auth/login');
  };

  const handleLogout = () => {
    // Redirect to home page after logout
    navigate('/');
  };

  return (
    <div className='min-h-screen'>
      {/* Enhanced Header */}
      <EnhancedHeader 
        onGetStarted={handleGetStarted} 
        onLogin={handleLogin}
        onLogout={handleLogout}
        variant="landing"
        transparent={true}
      />

      {/* Add padding top to account for fixed header */}
      <div className="pt-16 md:pt-20">
        {/* Hero Section with Animated Background */}
        <AnimatedBackground variant="hero">
          <section className='relative overflow-hidden'>
            <div className='container mx-auto px-4 py-12 sm:py-16 md:py-20 lg:py-32'>
              <div className='grid lg:grid-cols-12 gap-8 md:gap-12 items-start'>
                {/* Hero Content - Expanded width for better text presence */}
                <div className='order-2 lg:order-1 lg:col-span-7'>
                  {isMobile ? (
                    <MobileHero
                      onGetStarted={handleGetStarted}
                      onWatchDemo={handleWatchDemo}
                    />
                  ) : (
                    <HeroSection
                      onGetStarted={handleGetStarted}
                      onWatchDemo={handleWatchDemo}
                    />
                  )}
                </div>

                {/* Hero Illustration - Reduced width for better balance */}
                <div className='order-1 lg:order-2 lg:col-span-5'>
                  <HeroIllustration />
                </div>
              </div>
            </div>
          </section>
        </AnimatedBackground>

        {/* How It Works Section (3 Simple Steps) */}
        <div id="features">
          <FeaturesSection />
        </div>

        {/* Before and After Section */}
        <div id="demo">
          <BeforeAfterSection />
        </div>

        {/* Testimonials Section */}
        <div id="testimonials">
          <TestimonialsSection onGetStarted={handleGetStarted} />
        </div>

        {/* Pricing Tier Section */}
        <div id="pricing">
          <PricingSection onGetStarted={handleGetStarted} />
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
